<div class="p-3 bg" [ngStyle]="{'margin-top': ExamStatus === 'Start' ? '0' : '100px'}">
    <div class="container">
        <div class="el-breadcrmb-inner">

            <h5 style="color: #e04787;">Subject:
                {{PREP_ExamDetails.SubjectName}}, <span *ngIf="PREP_ExamDetails.classId <= '12'">Class
                    {{PREP_ExamDetails.classId}}</span> <span *ngIf="PREP_ExamDetails.classId > '12'">Class
                    {{PREP_ExamDetails.className}}</span>
            </h5>
            <ul>
                <li *ngIf="ExamStatus=='Start'"><i class="far fa-clock fa-2x " aria-hidden="true">
                        <b style="font-family:Verdana, Geneva, Tahoma, sans-serif"> {{Timer}}</b></i></li>
                <li *ngIf="ExamStatus=='Instruction'">

                    <a [routerLink]="['/required-configuration']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i>
                        Back</a>
                </li>
            </ul>
        </div>
    </div>
</div>



<div class="el-blog-single-wrapper">
    <div class="container">
        <div class="row gy-4">
            <div class="col-lg-12 col-md-12 ">

                <div class="el-blogsingle-img d-flex justify-content-center align-items-center flex-column"
                    *ngIf="ExamStatus=='Instruction'">
                    <div class="el-inner-blog-box el-blog-single">

                        <div class="p-3">

                            <div class="instrutions col-md-12  p-3" *ngIf="Instruction!=null">
                                <h3>Instruction :</h3>
                                <b>Read the instructions carefully before starting the Exam.</b>
                                <ul>

                                    <li>Attempt the test on a laptop/desktop for the best experience. If
                                        you're attempting the test on a mobile/tablet, make sure you're
                                        viewing the screen portrait mode.</li>
                                    <li>Please do not refresh the test page or open the test in multiple
                                        tabs at the same time.</li>
                                    <li>This test is of <strong>{{Instruction.ExamDuration}}</strong> minutes duration
                                        and the
                                        countdown will begin as soon as you click "<strong>I am ready to
                                            begin</strong>" Button.</li>
                                    <li>The test comprises <strong>{{Instruction.NOQ}}</strong> Questions across
                                        <strong>{{Instruction.TotalSection}}</strong>
                                        sections. <span [innerHtml]="Instruction.Statement"></span>
                                    </li>
                                    <li>The total test time is <strong>{{Instruction.ExamDuration}}</strong> minutes and
                                        the
                                        test will auto submit after <strong>{{Instruction.ExamDuration}}</strong>
                                        minutes.</li>
                                    <li>All questions are multiple-choice questions (MCQs) with only one
                                        correct option.</li>
                                    <li>There is no negative marking.</li>
                                    <li>
                                        To answer a question, do the following:
                                        <br />Click on any of the options for the currently shown question.
                                        Once you click either <strong>Previous</strong> or
                                        <strong>Next</strong> your answer will be saved.

                                    </li>
                                    <!-- <li>Rough work should be done on the blank sheet.</li> -->
                                    <li>The exam will automatically be submitted when the clock runs out of
                                        the exam time.</li>
                                    <li>The question palette at the right side (for Desktop/Laptop users)
                                        and at the bottom (for mobile users) shows attempted and unattempted
                                        questions.</li>
                                    <li>After attempting all the questions, to complete the test please
                                        click on the "<strong>Finish</strong>" button. DO NOT click on the
                                        "<strong>Finish</strong>" button before attempting all the
                                        questions.</li>
                                    <li>Each Question carries a unique
                                        additional weightage starting from <strong>.0001</strong> to
                                        <strong>.00{{Instruction.NOQ}}</strong> marks depending upon
                                        standard/difficulty level of the question.
                                    </li>
                                    <li>Once the test is submitted, the test cannot be attempted again.</li>
                                    <li><strong>The camera must be on all the time. In case, the
                                            camera is disconnected during the examination, the exam may be
                                            cancelled.</strong></li>
                                </ul>
                                <p style="margin-top:15px;"><strong>All the Best!</strong></p>


                            </div>

                            <div class="disclamer p-3 ">
                                <h3>Disclamer: </h3>
                                <label>
                                    <input title="Please tick" type="checkbox" [(ngModel)]="Disclamer" />

                                </label>
                                <app-read-more [content]="ReadMoreText" [limit]="145" [completeWords]="true">
                                </app-read-more>



                            </div>
                            <div class="el-blogsingle-img d-flex justify-content-center align-items-center flex-column">
                                <div class="col-md-3 mt-2" *ngIf="ExamStatus=='Instruction'">
                                    <select class="form-control" [(ngModel)]="CameraSource"
                                        (change)="SetCamera('CameraSource')">
                                        <option *ngFor="let data of CameraList; let i = index" [value]="data.value">
                                            {{data.text}}
                                        </option>
                                    </select>
                                </div>
                                <div id="camera-container " class="my-4 cam-bg">
                                    <video id="CameraId" class="cam-bg2" #CameraId autoplay>
                                    </video>
                                </div>
                                <canvas #canvas width="100%" height="100%"
                                    style="border: 1px solid red; display: none;"></canvas>
                                <p style="color: red;">{{msg}}</p>
                                <button class="el-btn mt-2 text-center" [disabled]="Disclamer==false"
                                    (click)="I_am_ready_to_begin()">I am ready to
                                    begin</button>
                            </div>



                        </div>
                    </div>


                </div>
                <div class="mb-5" *ngIf="ExamStatus=='Start'">
                    <div class="row ">

                        <div class="col-md-6">
                            <div class="el-inner-blog-box p-3">
                                <strong>
                                    <div class="d-flex justify-content-between  align-items-baseline">
                                        <div class="col-md-6">
                                            <i class="fa fa-exclamation-circle"
                                                [ngStyle]="{'cursor': 'pointer','color': Question.IsDought==1?'red':'#5cb85c','font-size': '20px'}"
                                                (click)="Dought_In_Question(Question)" title="Report Question">
                                            </i>
                                            &nbsp;&nbsp;
                                            <i class="fa fa-star" data-toggle="modal" data-placement="top"
                                                title="Mark/Un-Mark for review"
                                                style="font-size: 20px;color: orange;cursor: pointer;"
                                                (click)="Mark_For_Review()"></i>
                                            &nbsp;&nbsp;
                                            Question {{Question.QNo}}
                                        </div>


                                        <div class="col-md-6" style="text-align: right;">
                                            Marks :
                                            {{Question.MarksPerQuestion}}
                                        </div>
                                    </div>
                                </strong>


                                <hr>
                                <div class="row">
                                    <div class="col-md-12">
                                        <p *ngIf="Question.Direction!=null" style="color:#337ab7">
                                            <strong><u>{{Question.Direction}}</u></strong>
                                        </p>
                                        <div style="width:8%;float:left;padding-top:3px;"
                                            *ngIf="Question.ParagraphVoice!=null">
                                            <i class="fa fa-volume-up" style="font-size:12pt;color:red;"
                                                (click)="Play($event,Question,Question.ParagraphVoice,true)">
                                            </i>
                                        </div>
                                    </div>
                                    <br *ngIf="Question.Direction!=null" />
                                    <br *ngIf="Question.ParagraphVoice!=null" />
                                </div>

                                <div class="row">
                                    <div
                                        [ngStyle]="{'width':Question.ParagraphVoice!=null?'82%':'100%','float':'left'}">
                                        <div style="margin-left: 15px;">
                                            <strong style="font-family: Times New Roman, Times, serif; font-size:13pt"
                                                *ngIf="Question.ParagraphContaint!='' && Question.ParagraphContaint!=null">
                                                <app-read-more [content]="Question.ParagraphContaint" [limit]="250"
                                                    [completeWords]="true">
                                                </app-read-more>

                                            </strong>
                                        </div>

                                        <img *ngIf="Question.ParagraphImage!='' && Question.ParagraphImage!=null"
                                            src="{{Question.ParagraphImage}}" class="img-responsive"
                                            alt="If image is not visible, Please refresh page." />
                                    </div>
                                    <br />
                                </div>


                                <div class="row">
                                    <div class="col-md-12">
                                        <div style="width:8%;float:left;padding-top:3px;"
                                            *ngIf="Question.QuestionVoice==null && Question.ParagraphVoice!=null">

                                        </div>
                                        <div style="width:8%;float:left;padding-top:3px;"
                                            *ngIf="Question.QuestionVoice!=null">
                                            <i class="fa fa-volume-up" style="font-size:12pt;color:red;"
                                                (click)="Play($event,Question,Question.QuestionVoice,false)">
                                            </i>
                                        </div>
                                        <div
                                            [ngStyle]="{'width':(Question.QuestionVoice!=null || Question.ParagraphVoice)?'82%':'100%','float':'left'}">

                                            <strong *ngIf="Question.QuestionText!='' && Question.QuestionText!=null"
                                                [innerHTML]="Question.QuestionText"></strong>

                                            <img *ngIf="Question.QuestionImage!='' && Question.QuestionImage!=null"
                                                src="{{Question.QuestionImage}}" class="img-responsive"
                                                alt="If image is not visible, Please refresh page." />

                                        </div>
                                    </div>
                                </div>
                                <br />




                                <div class="col-md-12"
                                    [ngStyle]="{'border':Question.AnsId==opt.OptionId && Question.AnsId != null ?'8px  solid #5cb85c':'1px solid gray','margin-top':'10px','font-family': 'Times New Roman, Times, serif', 'font-size':'13pt','cursor':'pointer','border-radius':'8px'}"
                                    [ngClass]="{ 'd-none': opt.OptionId==null }"
                                    *ngFor="let opt of Question.Ques_Option;let i=index">

                                    <div class="row" style="padding:7px;" *ngIf="opt.OptionId!=null">
                                        <div style="width:8%;float:left;padding-top:3px;" *ngIf="opt.OptionVoice!=null">
                                            <i class="fa fa-volume-up" style="font-size:12pt;color:red;"
                                                (click)="Play($event,opt,opt.OptionVoice,false)">
                                            </i>
                                        </div>
                                        <div style="width:9%;float:left" (click)="Question.AnsId=opt.OptionId">

                                            <button
                                                style="border-radius:50%;background-color:#42a5f5;color:#f6f6f6;border:none;padding:8px;line-height:10px; ">
                                                <strong *ngIf="i==0">A</strong>
                                                <strong *ngIf="i==1">B</strong>
                                                <strong *ngIf="i==2">C</strong>
                                                <strong *ngIf="i==3">D</strong>

                                            </button>

                                        </div>
                                        <!-- style="width:{{opt.OptionVoice!=null?83:91}}%;float:left;padding-top:3px;" -->
                                        <div [ngStyle]="{'width':opt.OptionVoice!=null?'83%':'91%','float':'left','padding-top':'3px'}"
                                            (click)="Question.AnsId=opt.OptionId">

                                            <strong
                                                *ngIf="opt.OptionText!='' && opt.OptionText!=null">{{opt.OptionText}}</strong>
                                            <img *ngIf="opt.OptionImage!='' && opt.OptionImage!=null"
                                                src="{{opt.OptionImage}}" class="img-responsive"
                                                alt="If image is not visible, Please refresh page." />
                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="el-inner-blog-box" style="padding-bottom: 10px;">
                                <div class="row">
                                    <div style="width:50%;float:left">
                                        <button type="button"
                                            style="margin-left:5px !important;width: 16px;height: 16px;cursor: default;"></button>
                                        &nbsp; Not Attempted
                                    </div>
                                    <div style="width:50%;float:left">
                                        <button type="button"
                                            style="margin-left:5px !important;width: 16px;height: 16px; background-color: darkgray;cursor: default;"></button>
                                        &nbsp; Seen
                                    </div>
                                    <div style="width:50%;float:left">

                                        <button type="button"
                                            style="margin-left:5px !important;width: 16px;background-color: rgb(92, 184, 92);height: 16px;cursor: default;">
                                        </button>
                                        &nbsp;Attempted

                                    </div>
                                    <div style="width:50%;float:left">
                                        <i class="fa fa-star" data-toggle="modal" data-placement="top"
                                            title="Mark/Un-Mark for review"
                                            style="font-size: 20px;color: orange;cursor: default;"></i>
                                        <!-- <button type="button"
                                            style="margin-left:5px !important;background-color: orange;width: 16px;height: 16px;"></button> -->
                                        &nbsp;Marked for review
                                    </div>
                                </div>
                            </div>
                            <div class="el-inner-blog-box" *ngFor="let data of questionList | groupbyF: 'SectionName'">
                                <strong>{{data.key}}</strong>
                                <hr>
                                <div class="row">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <button type="button" [ngClass]="getClass(_qno)"
                                                *ngFor="let _qno of data.items" (click)="ShowQNo(_qno.QNo)">
                                                <strong>{{_qno.QNo}}</strong>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="el-inner-blog-box">
                                <h4 class="el-blog-title text-center">Live Camera</h4>
                                <hr>
                                <div class="row">
                                    <div
                                        class="el-blogsingle-img d-flex justify-content-center align-items-center flex-column">
                                        <div id="camera-container " class="my-4 cam-bg">
                                            <video id="CameraId" class="cam-bg2" #CameraId autoplay>
                                            </video>
                                        </div>
                                        <canvas #canvas width="100%" height="100%"
                                            style="border: 1px solid red; display: none;"></canvas>
                                        <p style="color: red;">{{msg}}</p>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="el-inner-blog-box footer-fix">
                                    <div class="container" style="padding: 0px;">
                                        <div class="d-flex justify-content-between  align-items-baseline btnsec">
                                            <span class="">
                                                <button class="el-btn mx-2" [disabled]="Index==0"
                                                    (click)="Previous()"><i class="fa fa-arrow-left"></i>&nbsp;
                                                    Pre</button>
                                                <button class="el-btn" [disabled]="Index==(questionList.length-1)"
                                                    (click)="Next()">Next
                                                    &nbsp;<i class="fa fa-arrow-right"></i></button>
                                            </span>
                                            <span class="">
                                                <a class="el-btn btn-success" (click)="Finish(true)" data-toggle="modal"
                                                    style="background-color: #198754;"
                                                    data-target="#exampleModal">Finish</a></span>
                                        </div>
                                    </div>
                                    <div class="py-2 footer-fix">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center align-items-center"
                    *ngIf="ExamStatus=='ExamSubmited'  &&(PREP_ExamDetails.MockSet.startsWith('Mock') || PREP_ExamDetails.MockSet.startsWith('Free'))">

                    <div class="col-md-6 el-inner-blog-box el-blog-single  form-page-box p-3">
                        <div class="col-md-12 py-2 text-center">
                            <strong style="font-size:18pt;color:green;">
                                <i class="fa fa-check-circle" aria-hidden="true"></i>
                                Exam Submitted
                                Successfully.</strong>
                            <br /><br />
                            <strong style="font-size:18pt;color:rgb(81, 0, 128);">Marks obtained
                                {{totalMarks}}/100</strong>
                            <br /><br />
                        </div>
                        <div class="col-md-12">
                            <div class="panel panel-default" *ngFor="let _ques of questionList">
                                <hr style="margin: 22px;">
                                <div class="panel-heading">
                                    <strong>

                                        Question {{_ques.QNo}}


                                        <span class="pull-right">Marks :
                                            {{_ques.MarksPerQuestion}}</span>
                                    </strong>
                                </div>
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <p *ngIf="_ques.Direction!=null" style="color:#337ab7">
                                                <strong><u>{{_ques.Direction}}</u></strong>
                                            </p>
                                            <div style="width:8%;float:left;padding-top:3px;"
                                                *ngIf="_ques.ParagraphVoice!=null">
                                                <i class="fa fa-volume-up" style="font-size:12pt;color:red;"
                                                    (click)="Play($event,_ques,_ques.ParagraphVoice,true)">
                                                </i>
                                            </div>
                                        </div>
                                        <br *ngIf="_ques.Direction!=null" />
                                        <br *ngIf="_ques.ParagraphVoice!=null" />
                                    </div>

                                    <div class="row">
                                        <div [style.width.%]="_ques.ParagraphVoice != null ? 82 : 100"
                                            style="float: left;">
                                            <div style="margin-left: 15px;">
                                                <strong
                                                    style="font-family: Times New Roman, Times, serif; font-size:13pt"
                                                    *ngIf="_ques.ParagraphContaint!='' && _ques.ParagraphContaint!=null ">
                                                    <app-read-more [content]="_ques.ParagraphContaint" [limit]="250"
                                                        [completeWords]="true">
                                                    </app-read-more>
                                                </strong>
                                            </div>
                                            <img *ngIf="_ques.ParagraphImage!='' && _ques.ParagraphImage!=null"
                                                src="{{_ques.ParagraphImage}}" class="img-responsive"
                                                alt="If image is not visible, Please refresh page." />
                                        </div>
                                        <br />
                                    </div>


                                    <div class="row">
                                        <div class="col-md-12">
                                            <div style="width:8%;float:left;padding-top:3px;"
                                                *ngIf="_ques.QuestionVoice==null && _ques.ParagraphVoice!=null">

                                            </div>
                                            <div style="width:8%;float:left;padding-top:3px;"
                                                *ngIf="_ques.QuestionVoice!=null">
                                                <i class="fa fa-volume-up" style="font-size:12pt;color:red;"
                                                    (click)="Play($event,_ques,_ques.QuestionVoice,false)">
                                                </i>
                                            </div>
                                            <div [style.width.%]="_ques.QuestionVoice != null || _ques.ParagraphVoice ? 82 : 100"
                                                style="float:left;">

                                                <strong *ngIf="_ques.QuestionText!='' && _ques.QuestionText!=null"
                                                    [innerHTML]="_ques.QuestionText"></strong>

                                                <img *ngIf="_ques.QuestionImage!='' && _ques.QuestionImage!=null"
                                                    src="{{_ques.QuestionImage}}" class="img-responsive"
                                                    alt="If image is not visible, Please refresh page." />

                                                <!-- (load)="onImageLoad(Question,'https://www.api.silverzone.online/'+Question.QuestionImage,2)" -->
                                            </div>
                                        </div>
                                    </div>
                                    <br />

                                    <div class="col-md-12" [style]="getColorForOptionCorrectOrNot(_ques,opt)"
                                        *ngFor="let opt of _ques.Ques_Option;let i=index"
                                        [ngClass]="{ 'd-none': opt.OptionId==null }">

                                        <div class="row" style="padding:7px;" *ngIf="opt.OptionId!=null">
                                            <div style="width:8%;float:left;padding-top:3px;"
                                                *ngIf="opt.OptionVoice!=null && opt.OptionVoice!=''">
                                                <i class="fa fa-volume-up" style="font-size:12pt;color:red;"
                                                    (click)="Play($event,opt,opt.OptionVoice,false)">
                                                </i>
                                            </div>
                                            <div style="width:9%;float:left">
                                                <button
                                                    style="border-radius:50%;background-color:#42a5f5;color:#f6f6f6;border:none;padding:8px;line-height:10px;">
                                                    <strong *ngIf="i==0">A</strong>
                                                    <strong *ngIf="i==1">B</strong>
                                                    <strong *ngIf="i==2">C</strong>
                                                    <strong *ngIf="i==3">D</strong>
                                                </button>
                                            </div>
                                            <div [style.width.%]="opt.OptionVoice != null ? 83 : 91"
                                                style="float:left; padding-top:3px;">
                                                <strong *ngIf="opt.OptionText!='' && opt.OptionText!=null"
                                                    [innerHtml]="opt.OptionText"></strong>
                                                <img *ngIf="opt.OptionImage!='' && opt.OptionImage!=null"
                                                    src="{{opt.OptionImage}}" class="img-responsive"
                                                    alt="If image is not visible, Please refresh page." />
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div class="panel-footer">
                                    <div class="row">
                                        <div class="col-md-12">
                                            Correct Answer:
                                            <strong *ngFor="let opt of _ques.Ques_Option;let i=index">
                                                <span *ngIf="i==0 && opt.OptionId==_ques.CorrectAnsId">A</span>
                                                <span *ngIf="i==1 && opt.OptionId==_ques.CorrectAnsId">B</span>
                                                <span *ngIf="i==2 && opt.OptionId==_ques.CorrectAnsId">C</span>
                                                <span *ngIf="i==3 && opt.OptionId==_ques.CorrectAnsId">D</span>
                                            </strong>

                                            <span class="pull-right">Marks Obtained: <strong>{{
                                                    _ques.AnsId ==
                                                    _ques.CorrectAnsId?_ques.MarksPerQuestion:0}}</strong>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between" style="padding-top:30px;">
                            <a [routerLink]="['/dashboard']" class="el-btn-outline ">
                                <i class="fa fa-home"></i>
                                &nbsp; Dashboard </a>
                            <button type="button" (click)="ExamStatus='FeedBack'" class=" el-btn-outline"> <i
                                    class="fa fa-send"></i> Share your Mock
                                Experience </button>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center align-items-center "
                    *ngIf="ExamStatus=='ExamSubmited' && PREP_ExamDetails.MockSet.startsWith('Pre')">
                    <button type="button" [routerLink]="['/report']" class=" el-btn-outline"> <i class="fa fa-send"></i>
                        View Progress Report and Rank

                    </button>

                    &nbsp;&nbsp;
                    <button type="button" (click)="ExamStatus='FeedBack'" class=" el-btn-outline"> <i
                            class="fa fa-send"></i> Share Your Experience </button>
                </div>


                <div class="d-flex justify-content-center align-items-center" *ngIf="ExamStatus=='FeedBack'">
                    <div class="col-md-6 el-inner-blog-box el-blog-single  form-page-box p-3">


                        <form [formGroup]="feedbackForm" (ngSubmit)="SaveFeedback()" novalidate>
                            <div class="row text-center">
                                <p style=" font-size: 22px; font-weight: bold;">We value your
                                    opinion.</p>
                                <p style="margin-top: 30px;"> How would you rate your overall experience</p>
                            </div>
                            <div class="row text-center">

                                <div class="d-flex justify-content-center">
                                    <div [ngClass]="{'input-error': _form.rating.invalid && _form.rating.touched}">
                                        <ngx-star-rating formControlName="rating"></ngx-star-rating>
                                    </div>
                                </div>

                                <!-- Error message -->
                                <div class="text-danger text-center"
                                    *ngIf="_form.rating.invalid && _form.rating.touched">
                                    Please rate your experience
                                </div>
                            </div>

                            <div class="el-input-field p-1">
                                <div class="text-center">
                                    Kindly take a moment to tell us what you
                                    think.
                                </div>

                                <textarea name="Remarks" formControlName="Remarks" class="" rows="4"
                                    [ngClass]="{'input-error':_form.Remarks.invalid && (_form.Remarks.touched || _form.Remarks.dirty)}"
                                    style="min-height: 40px;border: 1px;"></textarea>


                                <div *ngIf="_form.Remarks.invalid && (_form.Remarks.dirty || _form.Remarks.touched)"
                                    class="error ps-1">
                                    <div *ngIf="_form.Remarks.errors.required">
                                        Remarks is required
                                    </div>
                                    <div *ngIf="!_form.Remarks.errors.required && !_form.Remarks.errors.maxlength">
                                        Remarks should be 250 charectors
                                    </div>
                                </div>
                            </div>


                            <div class="d-flex justify-content-center" style="padding-top:30px;">
                                <!-- <a [routerLink]="['/report']" class="el-btn-outline ">
                                    <i class="fa fa-home"></i>
                                    &nbsp; View Progress Report </a> -->
                                <button type="submit" class=" el-btn-outline "> <i class="fa fa-save"></i> &nbsp;
                                    Submit </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>